/* istanbul ignore file */

/** This is a placeholder, not real render in dom */
const TreeNode = () => null;
export default TreeNode;